import { useToolCardById } from '@backrs_ui/grow-ui/src/pages/Home/hooks/stickerCardMapping';

import { ActionStickerCardSection, ToolsSectionParams } from './useGetToolsPageSections';

export const TOOLS_BACKRS_ASSESSMENTS_SECTION = ({
  navigate,
}: ToolsSectionParams): ActionStickerCardSection => {
  const { getStickerCard } = useToolCardById({ navigate });

  return {
    title: 'Backrs Assessments',
    description: 'Define your goals, measure your skills, and track your progress.',
    actionStickerCards: [
      getStickerCard('blueprint'),
      getStickerCard('are_you_on_track'),
      getStickerCard('life_readiness'),
    ],
  };
};
